import { MOBILE_AUTH_TOKEN_STORAGE_KEY } from '~/constants/mobile';

// NOTE: Non-greedy regexp to find the app key from filename
const DEVCENTER_APP_KEY_EXTRACTOR_REGEXP = /corva\.ai\/(.+?)\/packages/;
const PLATFORM_APP_KEY_EXTRACTOR_REGEXP = /app\/(.+?)\/.*\.chunk\.js/;

const isInsideIframe = window.self !== window.top;

export const getAppKeyAndId = () => {
  const xpropsAppKey = window?.xprops?.app?.app?.app_key;

  if (xpropsAppKey) {
    return {
      appKey: xpropsAppKey,
      appInstanceId: String(window?.xprops?.app?.id),
    };
  } else {
    const prevStackTraceLimit = Error.stackTraceLimit;
    Error.stackTraceLimit = 300;

    const error = new Error();
    const match =
      error.stack.match(DEVCENTER_APP_KEY_EXTRACTOR_REGEXP) ||
      error.stack.match(PLATFORM_APP_KEY_EXTRACTOR_REGEXP);

    Error.stackTraceLimit = prevStackTraceLimit;

    if (match) {
      return {
        appKey: match[1].replace('/app/', '.'),
        appInstanceId: 'nonisolated',
      };
    }
  }

  return undefined;
};

export function attachHTTPHeaders({ config, appKey, Authorization }) {
  const headers = { ...(config.headers || {}) };
  if (appKey) headers['x-corva-app'] = appKey;
  if (Authorization) headers.Authorization = Authorization;

  return { ...config, headers };
}

export const getAuthorizationToken = () => {
  try {
    const mobileAuthToken = sessionStorage.getItem(MOBILE_AUTH_TOKEN_STORAGE_KEY);
    if (mobileAuthToken) return mobileAuthToken;

    const url = isInsideIframe ? window.parent.location.href : window.location.href; // Get the current URL
    const params = new URL(url).searchParams; // Parse the URL query parameters
    return params.get('token'); // Extract the 'token' parameter
  } catch (error) {
    return null;
  }
};

export const getAuthorizationHeaders = () => {
  const token = getAuthorizationToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
